import { fetchPost } from '../Service/ApiService'
import { authmodel } from '../Provider/AuthProvider';

export const approvePurchasePartnerService = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`purchasepartnerservice/bulksend`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};

export const rejectPurchasePartnerService = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`purchasepartnerservice/bulkreject`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};








